import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
    state() {
        return {
            fundFocus: null,
            marketCommentary: null,
            researchReminders: [],
            readArticles: [],
            isLoadingFundFocus: false,
            hasLoadedFundFocus: false,
        };
    },
    mutations,
    actions,
    getters,
};
